import { CompanyTypesEnum, RolesEnum } from "../utils/Enums";
import Axios from "../../shared/infra/http/AxiosConfig";

export const saveAccountLogin = ({ token }) => {
  localStorage.setItem(process.env.REACT_APP_AUTH_TOKEN, token);
};

const parseJwt = token => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};

const loadUserFromStorage = () => {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_TOKEN);
  if (token) {
    return parseJwt(token);
  }
  return {};
};

export const getUser = () => loadUserFromStorage();
export const isContractor = () =>
  loadUserFromStorage().role === CompanyTypesEnum.Contractor;
export const isBenefited = () => loadUserFromStorage();
export const isHired = () =>
  loadUserFromStorage().role === CompanyTypesEnum.Hired;
export const isBackOffice = () =>
  loadUserFromStorage().role === RolesEnum.BackOffice;
export const isTechnician = () =>
  loadUserFromStorage().role === RolesEnum.Technician;
export const isManager = () => loadUserFromStorage().role === RolesEnum.Manager;
export const isOperator = () =>
  loadUserFromStorage().role === RolesEnum.Operator;

export const saveDeviceId = async deviceId => {
  const noHasDeviceId = !localStorage.getItem("deviceId");

  if (noHasDeviceId && deviceId) {
    await Axios.AxiosClient.post(
      "accounts/deviceinfo",
      {
        userId: getUser().uid,
        platform: "web",
        deviceId: deviceId
      },
      Axios.mergeCommonHeaders({})
    );

    localStorage.setItem("deviceId", deviceId);
  }
};

export const sendChatPush = async (
  orderServiceId,
  screen,
  message,
  title,
  email,
  protocol,
  customer,
  status,
  createDate
) => {
  await Axios.AxiosClient.post(
    `orderServices/${orderServiceId}/notifications`,
    {
      orderServiceId,
      screen,
      message,
      title,
      email,
      protocol,
      customer,
      status,
      createDate
    }
  );
};



// WEBPACK FOOTER //
// ./src/shared/service/AccountService.js